export default "__VITE_PUBLIC_ASSET__d998c231__"